import request from "@/utils/request";

export default function listMerchantNewsTypes(merchantId) {
    return request({
        url: `/merchantNewsType/agency/list/`+merchantId,
        method: 'get',
    })
}
